import React from 'react';
import Section from '../Section';
import cn from 'classnames';
import classes from   '../Section/section.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const DEFAULT_SECTIONS = [
  { name: FLABEL().STATUS_PENDING, key: 'pending' },
  { name: FLABEL().STATUS_PROGRESS, key: 'inProgress' },
  { name: FLABEL().STATUS_COMPLETE, key: 'complete' },
];

const PICKEDUP_SECTIONS = [
  { name: FLABEL().STATUS_PENDING, key: 'pending' },
  { name: FLABEL().STATUS_PROGRESS, key: 'inProgress' },
  { name: FLABEL().STATUS_PICKEDUP, key: 'pickedUp' },
];

const Sections = props => {
  const {
    showPopup,
    onFooterButtonPress,
    pendingCheckList,
    inProgressCheckList,
    completeCheckList,
    pickedUpCheckList,
    isPickedUpCol,
  } = props;

  const getCheckList = section => {
    switch (section.key) {
      case 'pending':
        return pendingCheckList;
      case 'inProgress':
        return inProgressCheckList;
      case 'complete':
        return completeCheckList;
      case 'pickedUp':
        return pickedUpCheckList;
      default:
        return [];
    }
  };

  const sections = isPickedUpCol ? PICKEDUP_SECTIONS : DEFAULT_SECTIONS;

  const isAllEmpty =
    (!pendingCheckList || pendingCheckList.length === 0) &&
    (!inProgressCheckList || inProgressCheckList.length === 0) &&
    (!completeCheckList || completeCheckList.length === 0) &&
    (!pickedUpCheckList || pickedUpCheckList.length === 0);

  return (
    <div className={cn('row mx-0 h-100', classes.colsWrapper)}>
      {sections.map(section => {
        const checkList = getCheckList(section);
        return (
          <Section
            {...props}
            key={section.name}
            section={section}
            checkList={checkList}
            showPopup={showPopup}
            onFooterButtonPress={onFooterButtonPress}
            count={checkList?.length}
            isAllEmpty={isAllEmpty}
          />
        );
      })}
    </div>
  );
};

export default Sections;
